export const useQuizStore = (): QuizStore => {
    const responseStoreName = 'responseList'
    const stepStoreName = 'stepList'
    const filledResponseStoreName = 'filledResponse'
    const quizInfo = "quizInfo"

    const getQuizInfo = () => {
        const info = localStorage.getItem(quizInfo) || undefined
        return  info ? JSON.parse(info) as quizInfoType : undefined
    }

    const setQuizInfo = (data: quizInfoType) => {
        localStorage.setItem(quizInfo, JSON.stringify({...data}))
    }

    const removeQuizInfo = () => {
        localStorage.removeItem(quizInfo)
    }

    const getResponsesList = () => {
        return localStorage.getItem(responseStoreName)?.split(';') || [];
    }

    const getResponses = () => {
        return localStorage.getItem(responseStoreName) || undefined
    }

    const setResponseList = (value: string) => {
        localStorage.setItem(responseStoreName, value)
    }

    const addResponse = (response: string) => {
        setResponseList(`${localStorage.getItem(responseStoreName)
            ? localStorage.getItem(responseStoreName) + ';'
            : ''}${response}`)
    }

    const removeResponses = () => {
        localStorage.removeItem(responseStoreName);
    }

    const getLastResponse = () => {
        const list = localStorage.getItem(responseStoreName)?.split(';');
        return list?.[list?.length - 1]?.split('-')?.[1] || ''
    }

    const getFilledResponses = () => {
        return localStorage.getItem(filledResponseStoreName)?.split(';') || [];
    }

    const setFilledResponses = (value: string) => {
        localStorage.setItem(filledResponseStoreName, value)
    }

    const addFilledResponse = (response: string) => {
        setFilledResponses(`${localStorage.getItem(filledResponseStoreName)
            ? localStorage.getItem(filledResponseStoreName) + ';'
            : ''}${response}`)
    }

    const removeFilledResponses = () => {
        localStorage.removeItem(filledResponseStoreName);
    }

    const getlastFilledStep = () => {
        return localStorage.getItem(filledResponseStoreName)?.split(';')?.pop()?.split('-')?.pop()?.trim()
    }


    const getStepsList = () => {
        return localStorage.getItem(stepStoreName)?.split(';') || [];
    }

    const getSteps = () => {
        return localStorage.getItem(stepStoreName) || undefined
    }

    const setStepList = (value: string) => {
        localStorage.setItem(
            stepStoreName, value);
    }

    const addStep = (step: string) => {
        setStepList(`${localStorage.getItem(stepStoreName)
            ? localStorage.getItem(stepStoreName) + ';'
            : ''}${step}`)
    }

    const removeSteps = () => {
        localStorage.removeItem(stepStoreName);
    }

    const getlastStep = () => {
        return localStorage.getItem(stepStoreName)?.split(';')?.pop()?.trim()
    }

    const getfirstStep = () => {
        return localStorage.getItem(stepStoreName)?.split(';')?.[0]
    }

    const getPrevState = () => {
        const stepStore = localStorage.getItem(stepStoreName)?.split(';')
        const resStore = localStorage.getItem(responseStoreName)?.split(';')
        if(stepStore && resStore && stepStore?.length >= 2 && resStore?.length >= 1) return {
            stateName: stepStore?.[stepStore?.length - 2].trim(),
            eventName: resStore?.[resStore?.length - 1].trim()
        }
        return undefined
    }

    const removeStore = () => {
        removeResponses()
        removeSteps()
        removeFilledResponses()
        removeQuizInfo()
    }
 
    return {
        getQuizInfo,
        setQuizInfo,
        getResponsesList,
        getResponses,
        setResponseList,
        addResponse,
        removeResponses,
        getLastResponse,
        getFilledResponses,
        setFilledResponses,
        addFilledResponse,
        removeFilledResponses,
        getStepsList,
        getSteps,
        setStepList,
        addStep,
        getlastStep,
        getlastFilledStep,
        getfirstStep,
        removeSteps,
        getPrevState,
        removeStore
    }
}

type QuizStore = {
    /** function to get responses list in localStorage */
    getQuizInfo: () => quizInfoType | undefined
    /** function to get responses list in localStorage */
    setQuizInfo: (data: quizInfoType) => void
    /** function to get responses list in localStorage */
    getResponsesList: () => Array<string>
    /** function to get responses in localStorage */
    getResponses: () => string | undefined
    /** function to set responses list in localStorage */
    setResponseList: (val: string) => void
    /** function to add response in localStorage */
    addResponse: (val: string) => void
    /** function to remove responses list in localStorage */
    removeResponses: () => void
    /** function to get last responses  in localStorage */
    getLastResponse: () => string 
    /** function to get responses list in localStorage */
    getFilledResponses: () => Array<string>
    /** function to set responses list in localStorage */
    setFilledResponses: (val: string) => void
    /** function to add response in localStorage */
    addFilledResponse: (val: string) => void
    /** function to remove responses list in localStorage */
    removeFilledResponses: () => void
    /** function to get steps list in localStorage */
    getStepsList: () => Array<string>
    /** function to get steps/question in localStorage */
    getSteps: () => string | undefined
    /** function to set steps list in localStorage */
    setStepList: (val: string) => void
    /** function to add step in localStorage */
    addStep: (val: string) => void
     /** function to get last step in localStorage */
    getfirstStep: () => string | undefined
    /** function to get last step in localStorage */
    getlastStep: () => string | undefined
    /** function toremove steps list in localStorage */
    getlastFilledStep: () => string | undefined
    /** function toremove steps list in localStorage */
    removeSteps: () => void
    /** function to get previous state in localStorage */
    getPrevState: () => {stateName: string, eventName: string} | undefined
    /** function to remove responses list and step list in localStorage */
    removeStore: () => void
}

type quizInfoType = {
    id: number
    name: string
    nodePrefix: string
    isFormInstance?: boolean
}